import React, { Component, PureComponent } from 'react'
import PropTypes from 'prop-types'

import { View, ActivityIndicator, StyleSheet } from 'react-native'

import { bindingTypes, listTypes } from '@adalo/constants'

import { sortItems, listsEqual } from '../../utils/lists'
import ActionWrapper from '../ActionWrapper'
import ListWrapper from './ListWrapper'

export class ListItem extends PureComponent {
  static contextTypes = {
    getBinding: PropTypes.func,
    getBindings: PropTypes.func,
    getBindingsList: PropTypes.func,
    getDatasources: PropTypes.func,
  }

  static childContextTypes = {
    getBinding: PropTypes.func,
    getBindings: PropTypes.func,
    getBindingsList: PropTypes.func,
  }

  getChildContext() {
    return {
      getBinding: this.getBinding,
      getBindings: this.getBindings,
      getBindingsList: this.getBindingsList,
    }
  }

  getBinding = objectId => {
    let { item, listId, object } = this.props
    const { getBinding } = this.context

    if (
      objectId === listId ||
      objectId === (object.dataBinding && object.dataBinding.id)
    ) {
      return item
    } else if (getBinding) {
      return getBinding(objectId)
    }
  }

  getBindings = () => {
    let { item, datasourceId, tableId } = this.props
    let { getBindings } = this.context

    let result = {}

    if (getBindings) {
      result = getBindings()
    }

    if (item) {
      let key = `${datasourceId}.${tableId}`
      result[key] = item.id
    }

    return result
  }

  getBindingsList = () => {
    const { getBindingsList } = this.context
    const { item } = this.props

    const bindingsList = getBindingsList()

    if (item) return bindingsList.concat([item.id])
    return bindingsList
  }

  render() {
    let {
      children,
      rowMargin,
      object,
      component,
      marginLeft,
      marginRight,
    } = this.props

    if (object.actions && Object.keys(object.actions).length > 0) {
      return (
        <ActionWrapper
          style={[styles.row, { marginBottom: rowMargin }]}
          bindingData={{}}
          object={object}
          component={component}
          hitSlop={0}
        >
          {children}
        </ActionWrapper>
      )
    }

    let marginSettings = { marginLeft, marginRight }

    return (
      <View
        style={[styles.row, marginSettings, { marginBottom: rowMargin }]}
        pointerEvents="box-none"
      >
        {children}
      </View>
    )
  }
}

export class WrappedListItem extends Component {
  render() {
    let { object, bindingData, component, renderChildren } = this.props

    let { rowMargin } = object.attributes
    let { marginLeft, marginRight } = object.layout

    let item = bindingData[0]
    let { datasourceId, tableId } = (item && item._meta) || {}
    let prototype = object.children[0]

    return (
      <ListItem
        listId={object.id}
        item={item}
        rowMargin={rowMargin}
        datasourceId={datasourceId}
        tableId={tableId}
        object={object}
        component={component}
        marginLeft={marginLeft}
        marginRight={marginRight}
      >
        {renderChildren([prototype], { [object.id]: item })}
      </ListItem>
    )
  }
}

export default class List extends Component {
  static contextTypes = {
    getBindings: PropTypes.func,
  }

  getColumnCount() {
    let { object } = this.props

    if (object.attributes.listType === listTypes.GRID) {
      return object.attributes.columnCount || 1
    }

    return 1
  }

  getListKey = () => {
    let { getBindings } = this.context
    let { object } = this.props

    // TODO: Figure out a better way to avoid virtualizedlist listKey errors
    if (!this.keySuffix) {
      this.keySuffix = Math.round(Math.random() * 100000)
    }

    let keySuffix = this.keySuffix

    let ids = Object.values(getBindings())

    return `list-${object.id}-${keySuffix}-${ids.join('.')}`
  }

  renderItem = ({ item }) => {
    let { object, component, renderChildren } = this.props
    let { dataBinding } = object
    let { attributes } = object
    let { rowMargin } = attributes
    let prototype = object.children[0]

    let { datasourceId, tableId } = dataBinding.source

    if (!prototype) {
      return null
    }

    return (
      <ListItem
        listId={object.id}
        item={item}
        rowMargin={rowMargin}
        datasourceId={datasourceId}
        tableId={tableId}
        object={object}
        component={component}
      >
        {renderChildren([prototype], {
          [object.id]: item,
        })}
      </ListItem>
    )
  }

  shouldComponentUpdate(newProps) {
    let { object, bindingData } = this.props
    let { dataBinding } = object

    if (!dataBinding || dataBinding.bindingType !== bindingTypes.LIST) {
      return true
    }

    return !listsEqual(bindingData, newProps.bindingData)
  }

  render() {
    let { object, bindingData } = this.props

    let { layout } = object
    let { rowMargin } = object.attributes

    if (
      object.dataBinding &&
      object.dataBinding.bindingType === bindingTypes.LIST &&
      !Array.isArray(bindingData)
    ) {
      return (
        <View style={styles.loader}>
          <ActivityIndicator />
        </View>
      )
    }

    let listItems = sortItems(bindingData, object.dataBinding)

    let marginBottom = listItems.length > 0 && rowMargin ? -1 * rowMargin : 0

    let wrapperStyles = {
      ...layout,
      marginBottom,
    }

    return (
      <View style={wrapperStyles} pointerEvents="box-none">
        <ListWrapper
          listKey={this.getListKey()}
          data={listItems}
          renderItem={this.renderItem}
          numberOfColumns={this.getColumnCount()}
          spacing={rowMargin}
          object={object}
        />
      </View>
    )
  }
}

const styles = StyleSheet.create({
  row: {
    // Something here?
  },
  input: {
    position: 'absolute',
  },
  loader: {
    paddingTop: 10,
    paddingBottom: 10,
    justifyContent: 'center',
    alignItems: 'center',
  },
})
